import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { LocaleService } from '@shared/services/locale.service';
import { ViewportService } from '@shared/services/viewport.service';
import { CookieService } from 'ngx-cookie-service';
declare var YT: any;

@Component({
	selector: 'app-video-modal',
	templateUrl: './video-modal.component.html',
	styleUrls: ['./video-modal.component.scss'],
})
export class VideoModalComponent implements OnInit {
	constructor(private dialog: MatDialog, public viewport: ViewportService, public locale: LocaleService) {}

	loadYouTubePlayer() {
		if (this.viewport.type !== 'desktop') {
			const windowHeight = window.innerHeight; // Get the window height
			const maxHeightPercentage = 70; // Set your desired max height percentage here

			// Calculate the height based on the percentage of the window height
			const calculatedHeight = (windowHeight * maxHeightPercentage) / 100;

			new YT.Player('player', {
				videoId: '7KZdwWxH-OM',
				width: 300,
				height: calculatedHeight,
				playerVars: {
					autoplay: 0,
					controls: 1,
					disablekb: 1,
					loop: 0,
					modestbranding: 1,
					rel: 0,
					showinfo: 0,
					mute: 0,
				},
				events: {
					onStateChange: this.onPlayerStateChange.bind(this),
				},
			});
		} else {
			new YT.Player('player', {
				videoId: '7KZdwWxH-OM',
				height: 500,
				playerVars: {
					autoplay: 0,
					controls: 1,
					disablekb: 1,
					loop: 0,
					modestbranding: 1,
					rel: 0,
					showinfo: 1,
				},
				events: {
					onStateChange: this.onPlayerStateChange.bind(this),
				},
			});
		}
	}

	onPlayerStateChange(event: any) {
		if (event.data === YT.PlayerState.ENDED) {
			event.target.stopVideo();
			this.closeDialog(); // Close the dialog directly after the video ends
		}
	}

	closeDialog(): void {
		const dialogRef = this.dialog.getDialogById('videoDialog'); // 'videoDialog' should match the ID set when opening the dialog
		if (dialogRef) {
			dialogRef.close(); // Close the dialog only if it exists
		}
	}

	ngOnInit(): void {
		// Initialize YouTube player after the API is ready
		(window as any).onYouTubeIframeAPIReady = () => {
			this.loadYouTubePlayer();
		};

		// If the API is already loaded, call the initialization function immediately
		if ((window as any).YT && (window as any).YT.Player) {
			this.loadYouTubePlayer();
		}
	}
}
